import { useState } from "react";
import LastMenu from "./LastMenu";

import Mainmenu from "./MainMenu";
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 

const Payment = () =>{

    const [showMenu, setShowMenu] = useState(true);
    const [showFrame1, setShowFrame1] = useState(false);
    const [showFrame2, setShowFrame2] = useState(false);
    const [showFrame3, setShowFrame3] = useState(false);
    const [showFrame4, setShowFrame4] = useState(false);
    const [showFrame5, setShowFrame5] = useState(false);
    const [showFrame6, setShowFrame6] = useState(false);
    const [showFrame7, setShowFrame7] = useState(false);

    
      const [time, setTime] = useState(new Date());

    return (
        <>
            <div className="frame1 animated-frame">
            What do you want to know more about?
            </div>
            {showMenu &&
                <div className="menu-btns animated-frame">
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(true);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                        setShowFrame7(false);
                    }}
                >Cancellation Policy</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(true);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                        setShowFrame7(false);
                    }}
                >Financial Aid</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(true);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                        setShowFrame7(false);
                    }}
                >Installments</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(true);
                        setShowFrame5(false);
                        setShowFrame6(false);
                        setShowFrame7(false);
                    }}
                >Invoice and Payment Methods</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(true);
                        setShowFrame6(false);
                        setShowFrame7(false);
                    }}
                >Tution</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(true);
                        setShowFrame7(false);
                    }}
                >Payment Status</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                        setShowFrame7(true);
                    }}
                >Restart the chat</button>
            </div>}

            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Cancallation Policy
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    View our payment, cancellation, and deferral policy here.
                   </div>
                    <LastMenu id={5} />
                </>
            )}

            {showFrame2 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Financial Aid
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Financial aid is not available for HBS Executive Education programs. A limited number of needs-based partial scholarships are available for most programs. After being accepted to the program, and prior to the program start, participants may request a statement of need form which will be reviewed by the scholarship committee.
                     </div>
                    <LastMenu id={5} />
                </>
            )}

            {showFrame3 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Installments
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Once accepted into the program, you can confirm payment options with our Finance Department at exed_finance@hbs.edu. Typically, participants can pay in installments as long as the full tuition fee is received 30 days prior to the program start date.
                    </div>
                    <LastMenu id={5} />
                </>
            )}

            {showFrame4 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Invoices and Payment Methods
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Invoices are sent upon acceptance into the program, and payment is due within 30 days of receipt. If the invoice is received within 30 days of the program start date, payment is due upon receipt. Payment can be made by company check, electronic bank wire transfer, or credit card (American Express, Discover, MasterCard, or Visa). You can view our payment, cancellation, and deferral policy here.
                   </div>
                    <LastMenu id={5} />
                </>
            )}

            {showFrame5 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Tuition
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Fees vary by program. The program fee includes tuition, single-occupancy accommodations, most meals, and all program materials. Travel and incidentals are not included.
                    </div>
                    <LastMenu id={5} />
                </>
            )}

            {showFrame6 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Payment Status
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Track the status of your payment through the My Account application portal.
                    </div>
                    <LastMenu id={5} />
                </>
            )}

            {showFrame7 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
            )}



        </>
    );
}

export default Payment;